export default {
  "welcome": {
    "welcome-to": "Bienvenue sur",
    "one-philly": "Un Philly,",
    "united-city": "Une ville unie!",
  },
  "city-offices": {
    "city-offices-title": "Bureaux de la ville",
    "city-offices-text-1": "Les bureaux de la ville sont ouverts pendant les heures normales de bureau. Certains services sont offerts en ligne ou sur rendez-vous. Pour en savoir plus, ",
    "city-offices-text-2": "renseignez-vous auprès de votre département d'intérêt.",
    "city-offices-closure-text": "",
    "trash-title": "Déchets et recyclage",
    "trash-text-1": "Les collectes des déchets et du recyclage se déroulent selon un calendrier des fêtes. Préparez le matériel un jour après votre journée habituelle.",
    "trash-text-2": "Pour en savoir plus, ",
    "trash-text-3": "consultez le calendrier des fêtes.",
    "trash-closure-text": "",
  },
  "services": {
    "trash": "Trouvez votre journée de collecte des déchets",
    "bill": "Payer une facture",
    "jobs": "Découvrez les offres d'emploi en ville",
    "property": "Rechercher un bien",
    "taxes": "Déposer et payer les taxes municipales",
    "recycle": "Recycler les feuilles d'automne",
    "visit": "Rendez visite à une personne incarcérée",
    "license": "Obtenir une licence",
    "popular-services": "Services populaires",
    "jump-to-all-services": "Accédez à tous les services",
    "services-by-topic": "Services par thème",
    "see-all-services": "Voir tous les services",
    "alerts": "Inscrivez-vous pour recevoir des alertes d'urgence",
  },
  "tools": {
    "parks-finder": "Outil de recherche de parcs et de loisirs",
    "contracts": "Hub de contrats",
    "school-time-activity": "Outil de recherche d'activités extrascolaires",
    "food-meal": "Outil de recherche de nourriture et de repas gratuit",
    "atlas": "Atlas",
    "primary": "Outil de recherche de soins primaires",
    "eclipse": "éCLIPSE",
    "mail-vote-remind": "Rappel de vote par courrier",
    "street-smart": "StreetSmartPHL",
    "commonly-used-tools": "Outils couramment utilisés",
    "see-all-tools": "Voir tous les outils",
  },
  "news": {
    "featured-news": "Actualités en vedette",
    "see-all-news": "Voir toutes les actualités",
  },
  "311": {
    "report-311": "Aidez à faire de Philadelphie la grande ville la plus sûre, la plus propre et la plus verte du pays. Signalez les terrains vacants, les graffitis, les voitures abandonnées et plus encore à Philly311.",
    "report-problem": "SIGNALER UN PROBLÈME",
    "track-request": "SUIVRE UNE DEMANDE",
    "ask-question": "POSER UNE QUESTION",
  },
  "stay-connected": {
    "stay-connected": "Restez connectés",
    "sign-up-email": "Inscrivez-vous pour recevoir des mises à jour par e-mail de la ville de Philadelphie",
    "sign-up": "Inscrivez-vous",
  },
  "footer": {
    "elected-officials": "Fonctionnaires élus",
    "mayor": "Maire",
    "city-council": "Conseil municipal",
    "courts": "Tribunaux",
    "district-attorney": "Procureur de district",
    "city-controller": "Contrôleur municipal",
    "sheriff": "Shérif",
    "city-commissioners": "Commissaires municipaux",
    "register-wills": "Registre des testaments",
    "open-govt": "Gouvernement ouvert",
    "code-charter": "Code et charte de Philadelphie",
    "city-records": "Records de la ville",
    "city-agency-regs": "Règlements des agences municipales",
    "executive-orders": "Ordres exécutifs",
    "honesty-govt": "L'honnêteté au sein du gouvernement",
    "voting-elections": "Vote et élections",
    "open-data": "Données ouvertes",
    "org-chart": "Organigramme de la ville",
    "explore-phila": "Explorez Philadelphie",
    "visit-phila": "Visitez Philadelphie",
  },
  "clean-green": {
    "clean-green": "Propre et écologique ",
    "clean-green-statement": "Notre ville se mobilise pour faire de Philadelphie la grande ville la plus sûre, la plus propre et la plus verte du pays, avec des opportunités économiques pour tous. Suivez la stratégie à l'échelle de la ville qui s'attaque aux problèmes de qualité de vie dans tous les quartiers.",
    "blocks-swept": "Blocs balayés",
    "abandoned-autos": "Véhicules abandonnés retirés",
    "properties-cleaned": "Propriétés nettoyées et scellées",
    "graffiti-removed": "Graffiti supprimé",
    "see-all-clean-green": "VOIR TOUT PROPRE ET VERT",
  },
  "mayor": {
    "mayor-details": "Cherelle L. Parker est la 100e maire de Philadelphie et la première femme à occuper ce poste en 341 ans. Résidente de longue date de la ville, elle s'engage à se battre chaque jour pour les habitants de Philadelphie.",
    "learn-more": "En savoir plus",
  },
  "city-council": {
    "city-council": "Conseil municipal",
    "district-council-member": "Membre du conseil de district",
    "council-member-al":  "Membre général du Conseil",
    "council-president": "Président du Conseil",
    "dep-majority-whip": "Whip adjoint de la majorité",
    "majority-whip": "Whip de la majorité",
    "minority-leader": "Leader de la minorité",
    "minority-whip": "Whip de la minorité",
    "majority-leader": "Leader de la majorité",
  }, 
  "philly-stat-360": {
    "ps360": "État de Philadelphie 360",
    "data-subheader": "Transformer les données en actions pour nos communautés.",
  },
};